<template>
    <div class="payment-container">
        <div v-if="url.length">
            <h2><img class="logo" src="/images/icon-paypalsmall.jpg"> PayPal</h2>
            <a :href="url">
                <img src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-medium.png" alt="Check out with PayPal" />
            </a>
        </div>
        <div v-else>
            Loading <i class="icon icon-spinner fa-spin"></i>
        </div>
  </div>
</template>

<script>
    export default {
        props: { public_id: {default: ''} },
        data: function() {
            return {
                url: '',
            }
        },
        created() {
            this.axios.get(window.gateway_url, { params: {
                public_id: this.public_id
            }}).then((response) => {
                let data  = response.data;
                if (typeof data.url !== 'undefined') {
                    this.url = response.data.url;
                }
                if (typeof response['data']['error'] !== 'undefined') {
                    this.$eventHub.$emit('setPaymentError', response.data.error);
                }
            }).catch((error) => {
                if (typeof error.response['data']['error'] !== 'undefined') {
                    this.$eventHub.$emit('setPaymentError', error.response.data.error);
                }
                console.log(error);
            });
        },
        methods: {
        }
    }
</script>